import React, { useState, useEffect, useRef } from 'react';
import { apiFetch } from '../../hooks/useApi';
import {
  UsersIcon, SearchIcon, CheckIcon, XIcon,
  ShieldIcon, RefreshIcon, BadgeCheckIcon,
  DocumentIcon, CameraIcon, AlertIcon, EyeIcon,
  LockIcon, UnlockIcon,
} from '../../components/Icons';

// ── Módulos disponíveis para permissões ─────────────────────
const MODULOS = [
  { id: 'visao_geral',  label: 'Visão Geral'        },
  { id: 'dashboard',    label: 'Dashboard Métricas'  },
  { id: 'transacoes',   label: 'Transações'          },
  { id: 'disputas',     label: 'Disputas'            },
  { id: 'utilizadores', label: 'Utilizadores'        },
  { id: 'anuncios',     label: 'Anúncios'            },
  { id: 'financeiro',   label: 'Financeiro'          },
  { id: 'facturas',     label: 'Facturas'            },
  { id: 'saldos',       label: 'Saldos'              },
  { id: 'publicidade',  label: 'Publicidade'         },
];

/* ─── Modal Bloquear / Desbloquear ────────────────────────── */
function ModalBloquear({ utilizador, onFechar, onConfirmar, salvando }) {
  const [motivo, setMotivo] = useState('');

  useEffect(() => { setMotivo(''); }, [utilizador]);

  if (!utilizador) return null;

  const bloqueando = utilizador.ativo !== false;

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:1000,
      display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'var(--card)',borderRadius:'16px',width:'100%',maxWidth:'440px',
        boxShadow:'0 20px 60px rgba(0,0,0,0.4)',overflow:'hidden'}}>

        {/* Header */}
        <div style={{
          padding:'20px 24px',
          background: bloqueando ? 'linear-gradient(135deg,#FEF2F2,#FFF)' : 'linear-gradient(135deg,#F0FDF4,#FFF)',
          borderBottom:'1px solid var(--border)',
          display:'flex',alignItems:'center',gap:'14px',
        }}>
          <div style={{
            width:'46px',height:'46px',borderRadius:'50%',flexShrink:0,
            background: bloqueando ? 'var(--danger-bg)' : 'var(--success-bg)',
            border: `2px solid ${bloqueando ? 'var(--danger-border)' : 'var(--success-border)'}`,
            display:'flex',alignItems:'center',justifyContent:'center',
          }}>
            {bloqueando
              ? <LockIcon size={20} color='var(--danger)'/>
              : <UnlockIcon size={20} color='var(--success)'/>
            }
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:'15px',fontWeight:'700',color:'var(--text-primary)'}}>
              {bloqueando ? 'Suspender conta' : 'Reactivar conta'}
            </div>
            <div style={{fontSize:'12px',color:'var(--text-muted)',marginTop:'1px'}}>
              {utilizador.nome || utilizador.email}
            </div>
          </div>
          <button onClick={onFechar} style={{background:'transparent',border:'none',
            cursor:'pointer',color:'var(--text-muted)',fontSize:'22px',lineHeight:1}}>×</button>
        </div>

        {/* Body */}
        <div style={{padding:'20px 24px'}}>
          {/* Info utilizador */}
          <div style={{
            background:'var(--surface)',borderRadius:'10px',padding:'12px 14px',
            marginBottom:'16px',display:'flex',alignItems:'center',gap:'10px',
          }}>
            <div style={{
              width:'38px',height:'38px',borderRadius:'50%',flexShrink:0,
              background: bloqueando ? 'var(--danger)' : 'var(--success)',
              display:'flex',alignItems:'center',justifyContent:'center',
              fontSize:'14px',fontWeight:'700',color:'#fff',overflow:'hidden',
            }}>
              {utilizador.foto_url
                ? <img src={utilizador.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                : (utilizador.nome||'?')[0].toUpperCase()
              }
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:'13px',fontWeight:'600'}}>{utilizador.nome||'Sem nome'}</div>
              <div style={{fontSize:'11px',color:'var(--text-muted)'}}>{utilizador.email} · {utilizador.tipo}</div>
            </div>
            <span className={`badge badge-${bloqueando ? 'success' : 'danger'}`} style={{fontSize:'10px'}}>
              {bloqueando ? 'Activa' : 'Suspensa'}
            </span>
          </div>

          {/* Aviso */}
          <div style={{
            background: bloqueando ? 'var(--danger-bg)' : 'var(--success-bg)',
            border: `1px solid ${bloqueando ? 'var(--danger-border)' : 'var(--success-border)'}`,
            borderRadius:'10px',padding:'11px 14px',marginBottom:'16px',
            fontSize:'12px',color: bloqueando ? 'var(--danger)' : 'var(--success)',
            display:'flex',gap:'8px',alignItems:'flex-start',
          }}>
            <AlertIcon size={14} color={bloqueando ? 'var(--danger)' : 'var(--success)'} style={{flexShrink:0,marginTop:'1px'}}/>
            <span>
              {bloqueando
                ? 'A conta será suspensa imediatamente. O utilizador não conseguirá fazer login nem aceder à plataforma.'
                : 'A conta será reactivada e o utilizador voltará a ter acesso total à plataforma.'
              }
            </span>
          </div>

          {/* Motivo (só no bloqueio) */}
          {bloqueando && (
            <div>
              <label style={{fontSize:'12px',fontWeight:'600',color:'var(--text-secondary)',
                display:'block',marginBottom:'6px',textTransform:'uppercase',letterSpacing:'0.5px'}}>
                Motivo da suspensão <span style={{fontWeight:'400',textTransform:'none',color:'var(--text-muted)'}}>(opcional)</span>
              </label>
              <textarea
                value={motivo}
                onChange={e => setMotivo(e.target.value)}
                rows={3}
                placeholder="Ex: Violação dos termos de uso, comportamento suspeito..."
                style={{
                  width:'100%',padding:'10px 12px',background:'var(--surface)',
                  border:'1px solid var(--border)',borderRadius:'8px',
                  fontSize:'13px',color:'var(--text-primary)',fontFamily:'inherit',
                  outline:'none',resize:'vertical',
                }}
                onFocus={e => e.target.style.borderColor='var(--danger)'}
                onBlur={e => e.target.style.borderColor='var(--border)'}
              />
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{padding:'16px 24px',borderTop:'1px solid var(--border)',
          display:'flex',gap:'8px',justifyContent:'flex-end',background:'var(--surface)'}}>
          <button className="btn btn-ghost" onClick={onFechar} disabled={salvando}>Cancelar</button>
          <button
            className="btn"
            disabled={salvando}
            onClick={() => onConfirmar(utilizador.id, !bloqueando, motivo)}
            style={{
              background: bloqueando ? 'var(--danger)' : 'var(--success)',
              color: '#fff',
              border: 'none',
              display: 'flex', alignItems: 'center', gap: '6px',
              boxShadow: bloqueando ? '0 2px 8px rgba(220,38,38,0.3)' : '0 2px 8px rgba(22,163,74,0.3)',
            }}>
            {bloqueando ? <LockIcon size={13}/> : <UnlockIcon size={13}/>}
            {salvando ? 'A processar...' : bloqueando ? 'Suspender conta' : 'Reactivar conta'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─── Modal Promover / Alterar tipo ───────────────────────── */
function ModalPromover({ utilizador, onFechar, onConfirmar, salvando }) {
  const [tipo,       setTipo]       = useState(utilizador?.tipo || 'cliente');
  const [permissoes, setPermissoes] = useState(utilizador?.permissoes || []);

  useEffect(() => {
    setTipo(utilizador?.tipo || 'cliente');
    setPermissoes(utilizador?.permissoes || []);
  }, [utilizador]);

  if (!utilizador) return null;

  const toggleModulo = (id) => {
    setPermissoes(prev =>
      prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
    );
  };

  const selecionarTodos = () => setPermissoes(MODULOS.map(m => m.id));
  const limparTodos     = () => setPermissoes([]);
  const podeConfirmar   = tipo !== 'admin' || permissoes.length > 0;

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,
      display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'var(--card)',borderRadius:'16px',width:'100%',maxWidth:'500px',
        boxShadow:'0 20px 60px rgba(0,0,0,0.4)',overflow:'hidden'}}>

        <div style={{padding:'20px 24px',borderBottom:'1px solid var(--border)',
          display:'flex',alignItems:'center',gap:'12px'}}>
          <div style={{width:'42px',height:'42px',borderRadius:'50%',background:'var(--orange)',
            display:'flex',alignItems:'center',justifyContent:'center',
            fontSize:'15px',fontWeight:'700',color:'#fff',flexShrink:0}}>
            {(utilizador.nome||'?')[0].toUpperCase()}
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:'15px',fontWeight:'700'}}>{utilizador.nome||'Sem nome'}</div>
            <div style={{fontSize:'12px',color:'var(--text-muted)'}}>{utilizador.email}</div>
          </div>
          <button onClick={onFechar} style={{background:'transparent',border:'none',
            cursor:'pointer',color:'var(--text-muted)',fontSize:'22px'}}>×</button>
        </div>

        <div style={{padding:'20px 24px'}}>
          <div style={{marginBottom:'18px'}}>
            <label style={{fontSize:'12px',fontWeight:'600',color:'var(--text-secondary)',
              display:'block',marginBottom:'8px',textTransform:'uppercase',letterSpacing:'0.5px'}}>
              Tipo de conta
            </label>
            <div style={{display:'flex',gap:'8px'}}>
              {[
                { id:'cliente',    label:'Cliente',          color:'var(--success)'   },
                { id:'fornecedor', label:'Fornecedor',       color:'var(--brand-mid)' },
                { id:'admin',      label:'Funcionário Admin',color:'var(--danger)'    },
              ].map(t => (
                <button key={t.id} onClick={() => setTipo(t.id)}
                  style={{flex:1,padding:'8px',borderRadius:'8px',fontSize:'12px',fontWeight:'600',
                    cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s',
                    background: tipo === t.id ? t.color : 'var(--surface)',
                    color:      tipo === t.id ? '#fff'   : 'var(--text-secondary)',
                    border:     `1px solid ${tipo === t.id ? t.color : 'var(--border)'}`,
                  }}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>

          {tipo === 'admin' && (
            <div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
                <label style={{fontSize:'12px',fontWeight:'600',color:'var(--text-secondary)',
                  textTransform:'uppercase',letterSpacing:'0.5px'}}>
                  Módulos com acesso
                </label>
                <div style={{display:'flex',gap:'8px'}}>
                  <button onClick={selecionarTodos}
                    style={{fontSize:'11px',color:'var(--brand-mid)',background:'transparent',
                      border:'none',cursor:'pointer',fontWeight:'600',padding:'2px'}}>
                    Seleccionar todos
                  </button>
                  <span style={{color:'var(--border)'}}>|</span>
                  <button onClick={limparTodos}
                    style={{fontSize:'11px',color:'var(--danger)',background:'transparent',
                      border:'none',cursor:'pointer',fontWeight:'600',padding:'2px'}}>
                    Limpar
                  </button>
                </div>
              </div>
              <div style={{background:'var(--surface)',borderRadius:'10px',padding:'4px',
                border:'1px solid var(--border)',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'2px'}}>
                {MODULOS.map(m => {
                  const ativo = permissoes.includes(m.id);
                  return (
                    <button key={m.id} onClick={() => toggleModulo(m.id)}
                      style={{display:'flex',alignItems:'center',gap:'8px',padding:'8px 10px',
                        borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',transition:'all 0.12s',
                        background: ativo ? 'var(--orange)' : 'transparent',
                        color:      ativo ? '#fff' : 'var(--text-secondary)',
                        border:     'none',fontSize:'12px',fontWeight: ativo ? '600' : '400',
                        textAlign:'left',
                      }}>
                      <div style={{width:'14px',height:'14px',borderRadius:'3px',flexShrink:0,
                        background: ativo ? 'rgba(255,255,255,0.3)' : 'var(--border)',
                        display:'flex',alignItems:'center',justifyContent:'center'}}>
                        {ativo && <CheckIcon size={10} color='#fff'/>}
                      </div>
                      {m.label}
                    </button>
                  );
                })}
              </div>
              {permissoes.length === 0 && (
                <div style={{marginTop:'8px',fontSize:'11px',color:'var(--danger)',
                  display:'flex',gap:'4px',alignItems:'center'}}>
                  <AlertIcon size={11}/> Selecciona pelo menos um módulo
                </div>
              )}
              <div style={{marginTop:'10px',background:'var(--info-bg)',borderRadius:'8px',
                padding:'10px 12px',fontSize:'11px',color:'var(--info)',
                border:'1px solid var(--info-border)'}}>
                💡 Acesso limitado aos módulos seleccionados. O super administrador tem acesso total.
              </div>
            </div>
          )}
        </div>

        <div style={{padding:'16px 24px',borderTop:'1px solid var(--border)',
          display:'flex',gap:'8px',justifyContent:'flex-end',background:'var(--surface)'}}>
          <button className="btn btn-ghost" onClick={onFechar}>Cancelar</button>
          <button className="btn btn-primary"
            disabled={salvando || !podeConfirmar}
            onClick={() => onConfirmar(utilizador.id, tipo, tipo === 'admin' ? permissoes : null)}
            style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <ShieldIcon size={13}/>
            {salvando ? 'A guardar...' : 'Confirmar alteração'}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─── Modal de revisão KYC ─────────────────────────────────── */
function ModalKyc({ utilizador, onFechar, onDecisao, salvando }) {
  const [motivo,     setMotivo]     = useState('');
  const [mostrarRej, setMostrarRej] = useState(false);
  const [imgZoom,    setImgZoom]    = useState(null);

  if (!utilizador) return null;

  const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const token = localStorage.getItem('kialuga_token');

  const KycFoto = ({ src, label, icon }) => {
    const [objectUrl, setObjectUrl] = useState(null);
    const [erro, setErro] = useState(false);
    const urlRef = useRef(null);

    useEffect(() => {
      if (!src) return;
      const filename = src.split('/').pop();
      fetch(`${BASE}/admin/kyc-documento?ficheiro=${encodeURIComponent(filename)}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(r => { if (!r.ok) throw new Error(); return r.blob(); })
        .then(blob => {
          const url = URL.createObjectURL(blob);
          urlRef.current = url;
          setObjectUrl(url);
        })
        .catch(() => setErro(true));
      return () => { if (urlRef.current) URL.revokeObjectURL(urlRef.current); };
    // eslint-disable-next-line
    }, [src]);

    return (
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'11px',fontWeight:'600',color:'var(--text-muted)',
          textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:'8px',
          display:'flex',alignItems:'center',gap:'5px'}}>
          {icon} {label}
        </div>
        {src ? (
          <div style={{position:'relative',borderRadius:'10px',overflow:'hidden',
            border:'1px solid var(--border)',cursor:objectUrl?'zoom-in':'default',
            background:'var(--surface)'}} onClick={() => objectUrl && setImgZoom(objectUrl)}>
            {objectUrl ? (
              <img src={objectUrl} alt={label}
                style={{width:'100%',height:'200px',objectFit:'cover',display:'block'}}/>
            ) : erro ? (
              <div style={{height:'200px',display:'flex',flexDirection:'column',
                alignItems:'center',justifyContent:'center',gap:'8px',color:'var(--text-muted)'}}>
                {icon}<span style={{fontSize:'12px'}}>Imagem indisponível</span>
              </div>
            ) : (
              <div style={{height:'200px',display:'flex',alignItems:'center',
                justifyContent:'center',color:'var(--text-muted)',fontSize:'12px'}}>
                A carregar...
              </div>
            )}
            {objectUrl && (
              <div style={{position:'absolute',bottom:'6px',right:'6px',
                background:'rgba(0,0,0,0.5)',borderRadius:'6px',padding:'3px 7px',
                fontSize:'10px',color:'#fff',display:'flex',alignItems:'center',gap:'4px'}}>
                <EyeIcon size={10} color='#fff'/> Ver em grande
              </div>
            )}
          </div>
        ) : (
          <div style={{height:'200px',border:'2px dashed var(--border)',borderRadius:'10px',
            display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',
            gap:'8px',background:'var(--surface)',color:'var(--text-muted)'}}>
            {icon}<span style={{fontSize:'12px'}}>Não submetido</span>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {imgZoom && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.92)',zIndex:2000,
          display:'flex',alignItems:'center',justifyContent:'center',cursor:'zoom-out',padding:'20px'}}
          onClick={() => setImgZoom(null)}>
          <img src={imgZoom} alt="documento"
            style={{maxWidth:'90vw',maxHeight:'90vh',borderRadius:'10px',objectFit:'contain',
              boxShadow:'0 0 60px rgba(0,0,0,0.8)'}}/>
          <button onClick={() => setImgZoom(null)}
            style={{position:'fixed',top:'20px',right:'24px',background:'rgba(255,255,255,0.15)',
              border:'none',color:'#fff',borderRadius:'50%',width:'40px',height:'40px',
              cursor:'pointer',fontSize:'20px',display:'flex',alignItems:'center',justifyContent:'center'}}>
            ×
          </button>
        </div>
      )}

      <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,
        display:'flex',alignItems:'center',justifyContent:'center',padding:'20px',overflowY:'auto'}}>
        <div style={{background:'var(--card)',borderRadius:'16px',width:'100%',maxWidth:'640px',
          boxShadow:'0 20px 60px rgba(0,0,0,0.4)',maxHeight:'90vh',overflow:'hidden',
          display:'flex',flexDirection:'column'}}>

          <div style={{padding:'20px 24px',borderBottom:'1px solid var(--border)',
            display:'flex',alignItems:'center',gap:'14px',flexShrink:0}}>
            <div style={{width:'46px',height:'46px',borderRadius:'50%',overflow:'hidden',
              background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',
              fontSize:'16px',fontWeight:'700',color:'#fff',flexShrink:0}}>
              {utilizador.foto_url
                ? <img src={utilizador.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                : (utilizador.nome||'?')[0].toUpperCase()
              }
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:'15px',fontWeight:'700',color:'var(--text-primary)'}}>{utilizador.nome||'Sem nome'}</div>
              <div style={{fontSize:'12px',color:'var(--text-muted)'}}>{utilizador.email} · {utilizador.telefone||'Sem telefone'}</div>
            </div>
            <button onClick={onFechar} style={{background:'transparent',border:'none',
              cursor:'pointer',color:'var(--text-muted)',fontSize:'22px',lineHeight:1,flexShrink:0}}>×</button>
          </div>

          <div style={{padding:'20px 24px',overflowY:'auto',flex:1}}>
            <div style={{background:'var(--surface)',borderRadius:'10px',padding:'12px 16px',
              marginBottom:'20px',display:'flex',alignItems:'center',gap:'10px'}}>
              <DocumentIcon size={16} color='var(--orange)'/>
              <div>
                <div style={{fontSize:'10px',color:'var(--text-muted)',textTransform:'uppercase',
                  letterSpacing:'0.4px',marginBottom:'2px'}}>Número BI / Passaporte</div>
                <div style={{fontSize:'14px',fontWeight:'700',color:'var(--text-primary)',letterSpacing:'1px'}}>
                  {utilizador.bi_numero || <span style={{fontStyle:'italic',fontSize:'13px',fontWeight:'400',color:'var(--text-muted)'}}>Não fornecido</span>}
                </div>
              </div>
            </div>

            <div style={{display:'flex',gap:'14px',marginBottom:'20px'}}>
              <KycFoto src={utilizador.bi_foto_url} label="Foto do BI / Passaporte" icon={<DocumentIcon size={14}/>}/>
              <KycFoto src={utilizador.selfie_url}  label="Selfie do titular"       icon={<CameraIcon   size={14}/>}/>
            </div>

            {!utilizador.bi_foto_url && !utilizador.selfie_url && (
              <div style={{background:'var(--warning-bg)',border:'1px solid var(--warning-border)',
                borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',fontSize:'13px',
                color:'var(--warning)',display:'flex',gap:'8px',alignItems:'center'}}>
                <AlertIcon size={14} color='var(--warning)'/>
                Este utilizador ainda não submeteu documentos de verificação.
              </div>
            )}

            {mostrarRej && (
              <div style={{marginBottom:'16px'}}>
                <label style={{fontSize:'12px',fontWeight:'500',color:'var(--text-secondary)',
                  display:'block',marginBottom:'5px'}}>
                  Motivo da rejeição (opcional)
                </label>
                <textarea value={motivo} onChange={e=>setMotivo(e.target.value)} rows={3}
                  placeholder="Ex: Foto do BI ilegível..."
                  style={{width:'100%',padding:'10px 12px',background:'var(--surface)',
                    border:'1px solid var(--danger-border)',borderRadius:'8px',
                    fontSize:'13px',color:'var(--text-primary)',fontFamily:'inherit',
                    outline:'none',resize:'vertical'}}/>
              </div>
            )}
          </div>

          <div style={{padding:'16px 24px',borderTop:'1px solid var(--border)',
            display:'flex',gap:'8px',justifyContent:'flex-end',flexShrink:0,background:'var(--surface)'}}>
            <button className="btn btn-ghost" onClick={onFechar}>Fechar</button>

            {utilizador.kyc_estado !== 'verificado' && utilizador.bi_foto_url && (
              <>
                {!mostrarRej ? (
                  <button className="btn btn-sm"
                    style={{background:'var(--danger-bg)',color:'var(--danger)',
                      border:'1px solid var(--danger-border)',display:'flex',alignItems:'center',gap:'5px',padding:'8px 14px'}}
                    onClick={() => setMostrarRej(true)}>
                    <XIcon size={13}/> Rejeitar KYC
                  </button>
                ) : (
                  <button className="btn btn-sm"
                    style={{background:'var(--danger-bg)',color:'var(--danger)',
                      border:'1px solid var(--danger-border)',display:'flex',alignItems:'center',gap:'5px',padding:'8px 14px'}}
                    disabled={salvando}
                    onClick={() => onDecisao(utilizador.id, 'rejeitado', motivo)}>
                    <XIcon size={13}/> {salvando?'A guardar...':'Confirmar rejeição'}
                  </button>
                )}
                <button className="btn btn-primary"
                  style={{display:'flex',alignItems:'center',gap:'5px',padding:'8px 18px'}}
                  disabled={salvando}
                  onClick={() => onDecisao(utilizador.id, 'verificado', '')}>
                  <CheckIcon size={13}/> {salvando?'A guardar...':'Aprovar KYC'}
                </button>
              </>
            )}

            {utilizador.kyc_estado === 'verificado' && (
              <div style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'13px',
                color:'var(--success)',fontWeight:'500'}}>
                <BadgeCheckIcon size={15}/> Identidade já verificada
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── Página principal ─────────────────────────────────────── */
export default function AdminUtilizadores() {
  const [lista,         setLista]         = useState([]);
  const [load,          setLoad]          = useState(true);
  const [search,        setSearch]        = useState('');
  const [filtro,        setFiltro]        = useState('todos');
  const [erro,          setErro]          = useState('');
  const [sucesso,       setSucesso]       = useState('');
  const [modalKyc,      setModalKyc]      = useState(null);
  const [modalPromover, setModalPromover] = useState(null);
  const [modalBloquear, setModalBloquear] = useState(null);
  const [salvando,      setSalvando]      = useState(false);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const data = await apiFetch('/admin/utilizadores');
      setLista(data.utilizadores || []);
    } catch(e) { setErro(e.message); }
    finally { setLoad(false); }
  };

  const mostrarSucesso = (msg) => { setSucesso(msg); setTimeout(() => setSucesso(''), 4000); };
  const mostrarErro    = (msg) => { setErro(msg);    setTimeout(() => setErro(''),    5000); };

  const decidirKyc = async (id, estado, motivo) => {
    setSalvando(true);
    try {
      await apiFetch('/admin/kyc/verificar', 'POST', { utilizador_id: id, estado, motivo });
      mostrarSucesso(`KYC ${estado === 'verificado' ? 'aprovado' : 'rejeitado'} com sucesso`);
      setModalKyc(null);
      carregar();
    } catch(e) { mostrarErro(e.message); }
    finally { setSalvando(false); }
  };

  const confirmarPromocao = async (id, tipo, permissoes) => {
    setSalvando(true);
    try {
      await apiFetch(`/admin/utilizadores/${id}/tipo`, 'PATCH', { tipo, permissoes });
      const labels = { cliente:'Cliente', fornecedor:'Fornecedor', admin:'Funcionário Admin' };
      mostrarSucesso(`Utilizador actualizado para ${labels[tipo] || tipo}`);
      setModalPromover(null);
      carregar();
    } catch(e) { mostrarErro(e.message); }
    finally { setSalvando(false); }
  };

  const confirmarBloqueio = async (id, ativo, motivo) => {
    setSalvando(true);
    try {
      await apiFetch(`/admin/utilizadores/${id}/ativar`, 'PATCH', { ativo, motivo });
      mostrarSucesso(ativo ? 'Conta reactivada com sucesso' : 'Conta suspensa com sucesso');
      setModalBloquear(null);
      carregar();
    } catch(e) { mostrarErro(e.message); }
    finally { setSalvando(false); }
  };

  const filtrados = lista.filter(u => {
    const q = search.toLowerCase();
    const matchSearch = !q || (u.nome||'').toLowerCase().includes(q) || (u.email||'').toLowerCase().includes(q);
    const matchFiltro =
      filtro === 'todos'       ? true :
      filtro === 'bloqueados'  ? u.ativo === false :
      filtro === 'kyc_pendente'? u.kyc_estado === 'pendente' && u.tipo !== 'admin' :
      filtro === 'admin'       ? u.tipo === 'admin' :
      u.tipo === filtro;
    return matchSearch && matchFiltro;
  });

  const tabs = [
    { id:'todos',        label:'Todos',        count: lista.length },
    { id:'cliente',      label:'Clientes',     count: lista.filter(u=>u.tipo==='cliente').length },
    { id:'fornecedor',   label:'Fornecedores', count: lista.filter(u=>u.tipo==='fornecedor').length },
    { id:'admin',        label:'Funcionários', count: lista.filter(u=>u.tipo==='admin').length },
    { id:'kyc_pendente', label:'KYC Pendente', count: lista.filter(u=>u.kyc_estado==='pendente'&&u.tipo!=='admin').length },
    { id:'bloqueados',   label:'Suspensos',    count: lista.filter(u=>u.ativo===false).length },
  ];

  const kycBadge = (u) => {
    if (u.kyc_estado==='verificado') return { cls:'badge-success', label:'Verificado' };
    if (u.kyc_estado==='rejeitado')  return { cls:'badge-danger',  label:'Rejeitado'  };
    return { cls:'badge-warning', label:'Pendente' };
  };

  return (
    <>
      <ModalKyc
        utilizador={modalKyc}
        onFechar={() => setModalKyc(null)}
        onDecisao={decidirKyc}
        salvando={salvando}
      />
      <ModalPromover
        utilizador={modalPromover}
        onFechar={() => setModalPromover(null)}
        onConfirmar={confirmarPromocao}
        salvando={salvando}
      />
      <ModalBloquear
        utilizador={modalBloquear}
        onFechar={() => setModalBloquear(null)}
        onConfirmar={confirmarBloqueio}
        salvando={salvando}
      />

      <div className="topbar">
        <div>
          <div className="topbar-title">Utilizadores</div>
          <div className="topbar-sub">
            {lista.length} registados · {lista.filter(u=>u.kyc_estado==='verificado').length} verificados
            {tabs[4].count > 0 && <span style={{color:'var(--warning)',fontWeight:'600'}}> · {tabs[4].count} KYC pendente{tabs[4].count!==1?'s':''}</span>}
            {tabs[5].count > 0 && <span style={{color:'var(--danger)',fontWeight:'600'}}> · {tabs[5].count} suspensa{tabs[5].count!==1?'s':''}</span>}
          </div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
        </div>
      </div>

      <div className="page-content">
        {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'11px 14px',marginBottom:'14px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'8px',alignItems:'center'}}><XIcon size={14}/>{erro}</div>}
        {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'11px 14px',marginBottom:'14px',fontSize:'13px',color:'var(--success)',display:'flex',gap:'8px',alignItems:'center'}}><CheckIcon size={14}/>{sucesso}</div>}

        {/* Filtros */}
        <div style={{display:'flex',gap:'8px',marginBottom:'14px',flexWrap:'wrap',alignItems:'center'}}>
          <div style={{display:'flex',alignItems:'center',gap:'6px',background:'var(--card)',
            border:'1px solid var(--border)',borderRadius:'8px',padding:'0 10px',
            flex:'1',minWidth:'200px',maxWidth:'320px'}}>
            <SearchIcon size={14} color='var(--text-muted)'/>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="Pesquisar por nome ou email..."
              style={{border:'none',outline:'none',background:'transparent',fontSize:'13px',
                color:'var(--text-primary)',padding:'8px 0',flex:1}}/>
          </div>
          <div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
            {tabs.map(t => {
              const isActive = filtro === t.id;
              const cor =
                t.id === 'bloqueados'   ? 'var(--danger)'  :
                t.id === 'kyc_pendente' ? 'var(--warning)' :
                t.id === 'admin'        ? '#7C3AED'        :
                'var(--orange)';
              return (
                <button key={t.id} onClick={() => setFiltro(t.id)} style={{
                  padding:'7px 12px',borderRadius:'8px',fontSize:'12px',fontWeight:'500',
                  cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s',
                  background: isActive ? cor : 'var(--card)',
                  color:      isActive ? '#fff' : 'var(--text-secondary)',
                  border:     `1px solid ${isActive ? cor : 'var(--border)'}`,
                }}>
                  {t.label} <span style={{opacity:0.75}}>({t.count})</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="card" style={{padding:0,overflow:'hidden'}}>
          <div className="table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Utilizador</th>
                  <th>Contacto</th>
                  <th>Tipo</th>
                  <th>KYC</th>
                  <th>Estado</th>
                  <th>Registo</th>
                  <th>Acções</th>
                </tr>
              </thead>
              <tbody>
                {load ? (
                  <tr><td colSpan={7} style={{textAlign:'center',padding:'40px',color:'var(--text-muted)'}}>A carregar...</td></tr>
                ) : filtrados.length === 0 ? (
                  <tr><td colSpan={7} style={{textAlign:'center',padding:'40px',color:'var(--text-muted)'}}>
                    <UsersIcon size={28} color='var(--border)'/><br/>
                    <span style={{marginTop:'8px',display:'block',fontSize:'13px'}}>Nenhum utilizador encontrado</span>
                  </td></tr>
                ) : filtrados.map(u => {
                  const badge    = kycBadge(u);
                  const temDocs  = !!(u.bi_foto_url || u.selfie_url);
                  const isAdmin  = u.tipo === 'admin';
                  const bloqueado= u.ativo === false;
                  const permCount= u.permissoes ? u.permissoes.length : null;

                  return (
                    <tr key={u.id} style={{opacity: bloqueado ? 0.65 : 1}}>
                      <td>
                        <div style={{display:'flex',alignItems:'center',gap:'9px'}}>
                          <div style={{position:'relative',flexShrink:0}}>
                            <div style={{
                              width:'34px',height:'34px',borderRadius:'50%',
                              background: bloqueado ? '#94A3B8' : isAdmin ? 'var(--danger)' : 'var(--orange)',
                              display:'flex',alignItems:'center',justifyContent:'center',
                              fontSize:'13px',fontWeight:'700',color:'#fff',overflow:'hidden',
                            }}>
                              {u.foto_url
                                ? <img src={u.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                                : (u.nome||u.email||'?')[0].toUpperCase()
                              }
                            </div>
                            {bloqueado && (
                              <div style={{
                                position:'absolute',bottom:'-2px',right:'-2px',
                                width:'14px',height:'14px',borderRadius:'50%',
                                background:'var(--danger)',border:'2px solid var(--card)',
                                display:'flex',alignItems:'center',justifyContent:'center',
                              }}>
                                <LockIcon size={7} color='#fff'/>
                              </div>
                            )}
                          </div>
                          <div>
                            <div style={{fontSize:'13px',fontWeight:'600',color:'var(--text-primary)'}}>{u.nome||'Sem nome'}</div>
                            <div style={{fontSize:'11px',color:'var(--text-muted)'}}>ID: {u.id?.slice(0,8)}…</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div style={{fontSize:'12px'}}>{u.email||'—'}</div>
                        <div style={{fontSize:'11px',color:'var(--text-muted)'}}>{u.telefone||'Sem telefone'}</div>
                      </td>
                      <td>
                        <div style={{display:'flex',flexDirection:'column',gap:'3px'}}>
                          <span className={`badge badge-${isAdmin?'danger':u.tipo==='fornecedor'?'info':'success'}`}
                            style={{textTransform:'capitalize'}}>
                            {isAdmin ? 'Admin' : u.tipo}
                          </span>
                          {isAdmin && (
                            <span style={{fontSize:'10px',color:'var(--text-muted)'}}>
                              {permCount === null ? '🔑 Super Admin' : `${permCount} módulo${permCount!==1?'s':''}`}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div style={{display:'flex',flexDirection:'column',gap:'4px'}}>
                          <span className={`badge ${badge.cls}`}>{badge.label}</span>
                          {u.bi_numero && <span style={{fontSize:'10px',color:'var(--text-muted)'}}>BI: {u.bi_numero}</span>}
                          {u.kyc_estado==='pendente' && temDocs && (
                            <span style={{fontSize:'10px',color:'var(--warning)',fontWeight:'600'}}>Docs prontos</span>
                          )}
                          {u.kyc_estado==='pendente' && !temDocs && (
                            <span style={{fontSize:'10px',color:'var(--text-muted)',fontStyle:'italic'}}>Aguarda docs</span>
                          )}
                        </div>
                      </td>
                      <td>
                        {bloqueado ? (
                          <span className="badge badge-danger" style={{display:'inline-flex',alignItems:'center',gap:'4px'}}>
                            <LockIcon size={9}/> Suspensa
                          </span>
                        ) : (
                          <span className="badge badge-success" style={{display:'inline-flex',alignItems:'center',gap:'4px'}}>
                            <CheckIcon size={9}/> Activa
                          </span>
                        )}
                      </td>
                      <td style={{fontSize:'11px',color:'var(--text-muted)'}}>
                        {new Date(u.created_at).toLocaleDateString('pt-PT')}
                      </td>
                      <td>
                        <div style={{display:'flex',gap:'5px',flexWrap:'wrap',alignItems:'center'}}>
                          {/* Ver documentos KYC */}
                          {(u.kyc_estado==='pendente' || temDocs) && !isAdmin && (
                            <button className="btn btn-sm"
                              style={{
                                background: u.kyc_estado==='pendente'&&temDocs ? 'var(--orange)' : 'var(--surface)',
                                color:      u.kyc_estado==='pendente'&&temDocs ? '#fff' : 'var(--text-secondary)',
                                border:     `1px solid ${u.kyc_estado==='pendente'&&temDocs ? 'var(--orange)' : 'var(--border)'}`,
                                display:'flex',alignItems:'center',gap:'4px',
                                fontWeight: u.kyc_estado==='pendente'&&temDocs ? '600' : '400',
                              }}
                              onClick={() => setModalKyc(u)}>
                              <EyeIcon size={12}/> {u.kyc_estado==='pendente'&&temDocs ? 'Rever KYC' : 'Ver docs'}
                            </button>
                          )}

                          {u.kyc_estado==='verificado' && (
                            <button className="btn btn-ghost btn-sm"
                              style={{display:'flex',alignItems:'center',gap:'4px',
                                color:'var(--success)',fontSize:'11px'}}
                              onClick={() => setModalKyc(u)}>
                              <BadgeCheckIcon size={12}/> Verificado
                            </button>
                          )}

                          {/* Gerir acesso */}
                          <button className="btn btn-ghost btn-sm"
                            onClick={() => setModalPromover(u)}
                            style={{display:'flex',alignItems:'center',gap:'4px',fontSize:'11px',
                              color: isAdmin ? 'var(--danger)' : 'var(--text-secondary)'}}>
                            <ShieldIcon size={12}/>
                            {isAdmin ? 'Gerir acesso' : 'Promover'}
                          </button>

                          {/* Bloquear / Desbloquear — não se aplica a admins */}
                          {!isAdmin && (
                            <button className="btn btn-sm"
                              onClick={() => setModalBloquear(u)}
                              style={{
                                display:'flex',alignItems:'center',gap:'4px',fontSize:'11px',
                                background: bloqueado ? 'var(--success-bg)' : 'var(--danger-bg)',
                                color:      bloqueado ? 'var(--success)'    : 'var(--danger)',
                                border:     `1px solid ${bloqueado ? 'var(--success-border)' : 'var(--danger-border)'}`,
                              }}>
                              {bloqueado ? <UnlockIcon size={11}/> : <LockIcon size={11}/>}
                              {bloqueado ? 'Reactivar' : 'Suspender'}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
